import { Box, Card, styled } from '@mui/material';

const ORGANIZER = (window as any).REACT_APP_ORGANIZER || 'buszrent';

export const PageHeader = styled(Box)`
    background-image: url('https://brspc.fra1.digitaloceanspaces.com/assets/img/${ORGANIZER}/header-background.svg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    width: 100%;
`;

export const Greeter = styled(Box)`
    color: white;
    display: flex;
    align-items: center;
`;

export const StyledBusCard = styled(Card)`
    padding: 8px 8px;
    position: relative;
    height: 120px;
    &:hover {
        border: 2px solid #4db6ac;
    }
`;

export const StyledDetailsBox = styled(Box)`
    min-height: 80vh;
    height: fit-content;
    padding: 4px 4px;
    width: 100%;
    flex-direction: column;
    display: flex;
`;

export const ConfirmCard = styled(Card)`
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -30%);
    width: auto;
    min-width: 400px;
    background-color: white;
    box-shadow: 2px 2px;
    padding-bottom: 14px;

    @media (max-width: 900px) {
        position: absolute;
        top: 100px;
        left: 0;
        right: 0;
        bottom: 0;
        transform: translate(0%, 0%);
        width: 100%;
    }
`;

export const StyledQRCodeList = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
`;

export const StyledQRCodeCard = styled(Card)`
    position: relative;
    width: 220px;
    height: 230px;
    display: grid;
    grid-template-rows: 0.7fr 2fr 1fr;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #bdbdbd;

    &:hover {
        border: 2px solid #4db6ac;
    }
`;

export const StyledQRCodeImageContainer = styled(Box)`
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 140%;
        height: 140%;
        max-width: none;
        object-fit: contain;
    }
`;